function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import * as su from './styleUtils';
import * as theme from './theme';
export const title = /*#__PURE__*/css(su.fontSans, su.text2xl, {
  color: theme.colors.text.primary,
  fontWeight: '700'
}, process.env.NODE_ENV === "production" ? "" : ";label:title;");
export const subTitle = /*#__PURE__*/css(su.fontSans, su.textLg, {
  color: theme.colors.text.primary,
  fontWeight: '700'
}, process.env.NODE_ENV === "production" ? "" : ";label:subTitle;");
export const regular = /*#__PURE__*/css(su.fontSans, su.textSm, {
  color: theme.colors.text.primary
}, process.env.NODE_ENV === "production" ? "" : ";label:regular;");
export const emptyLarge = /*#__PURE__*/css(su.fontSans, {
  color: theme.colors.text.faint,
  fontStyle: 'italic',
  fontWeight: '300'
}, process.env.NODE_ENV === "production" ? "" : ";label:emptyLarge;");
export const emptySmall = /*#__PURE__*/css(emptyLarge, su.textSm, process.env.NODE_ENV === "production" ? "" : ";label:emptySmall;");

// TODO: Things like flex should not be in typography styles.
export const label = /*#__PURE__*/css(su.fontSans, {
  color: theme.colors.text.secondary,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end'
}, su.textLabelSize, process.env.NODE_ENV === "production" ? "" : ";label:label;");
export const placeholder = /*#__PURE__*/css(su.fontSans, {
  color: theme.colors.text.hint
}, process.env.NODE_ENV === "production" ? "" : ";label:placeholder;");
export const inputText = /*#__PURE__*/css(su.fontSans, {
  color: theme.colors.text.primary
}, process.env.NODE_ENV === "production" ? "" : ";label:inputText;");
export const inputHelper = /*#__PURE__*/css(regular, su.textXs, su.fontInputHelper, {
  color: theme.colors.input.adornment,
  fontWeight: '300'
}, process.env.NODE_ENV === "production" ? "" : ";label:inputHelper;");
export const clickableLink = /*#__PURE__*/css(su.fontSans, {
  cursor: 'pointer',
  color: theme.colors.palettes.primary.main,
  '&:hover': process.env.NODE_ENV === "production" ? {
    name: "1wbll7q",
    styles: "text-decoration:underline"
  } : {
    name: "1ag045h---hover",
    styles: "text-decoration:underline;label:--hover;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  '&:disabled, &[data-disabled=true]': /*#__PURE__*/css({
    color: theme.colors.action.disabledBackground,
    cursor: 'default'
  }, process.env.NODE_ENV === "production" ? "" : ";label:--disabled----data-disabled-true-;"),
  '&[data-read-only=true]': /*#__PURE__*/css({
    color: theme.colors.text.primary,
    cursor: 'default',
    textDecoration: 'none'
  }, process.env.NODE_ENV === "production" ? "" : ";label:--data-read-only-true-;")
}, process.env.NODE_ENV === "production" ? "" : ";label:clickableLink;");
export const count = /*#__PURE__*/css(su.fontSans, su.textXs, {
  color: theme.colors.text.hint
}, process.env.NODE_ENV === "production" ? "" : ";label:count;");
export const warning = /*#__PURE__*/css({
  color: theme.colors.toasts.warning,
  fontStyle: 'italic'
}, process.env.NODE_ENV === "production" ? "" : ";label:warning;");
export const removed = /*#__PURE__*/css({
  textDecoration: 'line-through',
  color: theme.colors.text.errorText
}, process.env.NODE_ENV === "production" ? "" : ";label:removed;");